<template>
    <div class="ui top right attached large label"
        style="background: rgba(0,0,0,0); border-radius: 0px;text-align: center;"
        :style="{
            borderColor: statuses_border_color,
            padding: (style.width < 350) ? '.7em .7em' : '',
            paddingBottom: padding_bottom
        }">
        <span v-if="is_initialized && current_last_statuses"
            :data-tooltip="current_last_statuses.description"
            :style="{
                fontSize: ((style.width < 350) && (current_last_statuses.name.length > 5)) ? '12px' : ''
            }">
            {{current_last_statuses.name}}
            <p v-if="core_waybill.storage_number" style="font-size: 0.8em;color: gray;">@{{ core_waybill.storage_number }}</p>
        </span>
        <span v-else
            :style="{
                fontSize: (style.width < 350) ? '13px' : ''
            }">
            {{ $t('ui.pages.core_waybills.status.no_latest_status') }}
            <p v-if="core_waybill.storage_number" style="font-size: 0.8em;color: gray;">@{{ core_waybill.storage_number }}</p>
        </span>
    </div>

</template>

<script>
export default {
    components: {
    },
    props: {
        core_waybill: {
            default: {},
            type: Object
        },
        statuses: {
            default: function () { return [] },
            type: Array
        },
    },
    data: function () {
        return {
            is_initialized: false,
            current_last_statuses: {},
            statuses_border_color: "",
            statuses_colors: require("./../statues_color.json"),
        }
    },
    computed: {
        style() {
            return this.$store.state.style
        },
        padding_bottom() {
            return this.core_waybill.storage_number ? '0':'.75em'
        }
    },
    watch: {
        'core_waybill.latest_status'() {
            this.init()
        },
        statuses() {
            this.init()
        },
    },
    mounted() {
        this.init()
    },
    methods: {
        async init() {
            await this.set_current_last_statuses()
            await this.set_color()
            await new Promise(resolve => {
                this.is_initialized = true
            })
        },
        set_current_last_statuses() {
            var reslut = _.findLast(this.statuses, (status) => {
                return status.scope == "operator"
            })

            if (reslut) {
                this.current_last_statuses = reslut
            } else {
                this.current_last_statuses = this.core_waybill.latest_status
            }

            return Promise.resolve()
        },
        set_color() {
            try {
                if (!this.current_last_statuses) {
                    throw "dont current_last_statuses"
                }

                var result = _.findLast(this.statuses_colors, (statuses_color) => {
                    return statuses_color.name == this.current_last_statuses.name
                })

                if (result) {
                    this.statuses_border_color = result.color
                }else {
                    throw "dont find"
                }
            } catch (e) {
                this.statuses_border_color = "#666"
            }

            return Promise.resolve()
        },
    },
}
</script>

<style lang="scss" scoped>
    .top.label {
        border-bottom: 3px solid;
    }
</style>
